import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";

interface StateLicenseTax {
    id: number;
    state_type: string;
    amount: number;
    business_type: number;
    multi_member_status: boolean;
}

export interface RenewalData {
    id: number;
    package: number;
    package_name: string;
    package_amount: number;
    state_license_tax: StateLicenseTax[];
}

export const renewalApi = createApi({
    reducerPath: "renewalApi",
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getRenewalData: builder.query<RenewalData[], number>({
            query: (companyID) => `/client-renewal/${companyID}/`
        })
    })
})

export const {useGetRenewalDataQuery} = renewalApi;